/** i18n piatto (pattern Sequo/TILT). IT/EN dal giorno 1, default EN (portali internazionali). */

export type Lang = 'en' | 'it';

const STORAGE_KEY = 'wake:lang';

const dict = {
  'tagline': { en: 'One finger. A ribbon of light.', it: 'Un dito. Un nastro di luce.' },
  'hint.hold': {
    en: 'HOLD to dive down the slopes, RELEASE to fly off the crests.',
    it: 'PREMI per tuffarti in discesa, RILASCIA per volare oltre le creste.',
  },
  'hint.start': { en: 'Tap to start', it: 'Tocca per iniziare' },
  'go': { en: 'GO!', it: 'VIA!' },
  'action.retry': { en: 'RETRY', it: 'RIPROVA' },
  'finish.title': { en: 'FINISH', it: 'TRAGUARDO' },
  'finish.best': { en: 'NEW BEST!', it: 'NUOVO RECORD!' },
  'finish.ghost': { en: 'vs your ghost', it: 'vs il tuo ghost' },
  'hud.best': { en: 'BEST', it: 'RECORD' },
  'hud.wipeout': { en: 'WIPEOUT', it: 'CADUTA' },
  'menu.tracks': { en: 'CHOOSE YOUR TRACK', it: 'SCEGLI LA PISTA' },
  'menu.pb': { en: 'PB', it: 'REC' },
  'action.change': { en: 'CHANGE TRACK', it: 'CAMBIA PISTA' },
  'cue.hold': { en: 'HOLD — dive!', it: 'TIENI — tuffati!' },
  'cue.release': { en: 'RELEASE — fly!', it: 'LASCIA — vola!' },
  'track.daily': { en: "Today's track", it: 'Pista di oggi' },
  'track.warmup': { en: 'Warm-up', it: 'Riscaldamento' },
  'track.classic': { en: 'Rolling hills', it: 'Colline' },
  'track.steep': { en: 'The crest', it: 'La cresta' },
  'track.random': { en: 'Random track', it: 'Pista casuale' },
} as const;

export type I18nKey = keyof typeof dict;

let current: Lang = detect();

function detect(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'it') return saved;
    return (navigator.language || 'en').toLowerCase().startsWith('it') ? 'it' : 'en';
  } catch {
    return 'en';
  }
}

export function getLang(): Lang {
  return current;
}

export function setLang(l: Lang): void {
  current = l;
  try {
    localStorage.setItem(STORAGE_KEY, l);
  } catch {
    /* localStorage non disponibile: si resta in memoria */
  }
}

export function t(key: I18nKey): string {
  return dict[key][current];
}
